module.exports = __webpack_public_path__ + "img/2_top2.eceb4695.png";